import { Grid } from '@mui/material';
import { useMedicalCenterList } from 'app/hooks';
import { Breadcrumb, Button, List, ListWrapperDiv, TextField } from 'app/shared';
import { ROUTES } from 'app/utils';
import { t } from 'i18next';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const MedicalCenterList = () => {
  const { list, count, page, handlePageChange, pageSize, handlePageSizeChange, loading, handleFilter } =
    useMedicalCenterList();

  const navigate = useNavigate();

  const [search, setSearch] = useState<string>();

  const handleSearch = (newSearch?: string) => {
    setSearch(newSearch);
  };

  return (
    <>
      <Breadcrumb />
      <ListWrapperDiv>
        <Grid container spacing={2} paddingBottom={2} display={'flex'} alignItems={'center'}>
          <Grid size={4}>
            <TextField
              value={search}
              size="small"
              onChange={(e) => handleSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleFilter(search);
                  e.preventDefault();
                }
              }}
            />
          </Grid>
          <Grid size={4}>
            <Button
              onClick={() => {
                handleFilter(search);
              }}
            >
              {t('actions.search')}
            </Button>
          </Grid>
        </Grid>
        <List
          list={list}
          count={count}
          page={page}
          pageSize={pageSize}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          loading={loading}
          keyGetter={(el) => el.id}
          onItemClick={(el) => navigate(el.id)}
          actions={<Button onClick={() => navigate(ROUTES.new)}>{t('actions.create')}</Button>}
          fields={[
            {
              key: 'name',
              title: t('medicalCenter.name'),
            },
            {
              key: 'user_email',
              title: t('medicalCenter.email'),
            },
            {
              key: 'vat_number',
              title: t('medicalCenter.vatNumber'),
            },
          ]}
        />
      </ListWrapperDiv>
    </>
  );
};
